import { useSyncExternalStore } from 'react'

/** Half and half, so both versions are there to be seen before anything is moved. */
export const INITIAL_SPLIT_FRACTION = 0.5

/**
 * How the fraction reaches CSS: set on the element that draws it, as its own
 * inline style, so the gradient and its colours stay in the stylesheet while
 * only the number changes.
 */
export const SPLIT_FRACTION_VAR = '--compare-split-fraction'

let fraction = INITIAL_SPLIT_FRACTION
const listeners = new Set<() => void>()

/**
 * Where the split's line sits, from the left, 0-1. Held outside React so the
 * slider can move it at pointer rate without rendering anything, and read by
 * whoever draws the same proportion - which then re-renders on its own, rather
 * than everything that happens to sit above it.
 *
 * Only ever one split, so one value does.
 */
export function setSplitFraction(next: number) {
  if (next === fraction) return

  fraction = next
  listeners.forEach(listener => listener())
}

/** Back to the middle, for the next split to start where the first one did. */
export function resetSplitFraction() {
  setSplitFraction(INITIAL_SPLIT_FRACTION)
}

export function useSplitFraction(): number {
  return useSyncExternalStore(
    listener => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => fraction,
    // The server has no split to draw
    () => INITIAL_SPLIT_FRACTION
  )
}
